const SceneKeys = {
    PRELOADER: 'preloader',
    CREDITS: 'credits',
    TITLE_SCREEN: 'title-screen',
    GAME: 'game',
};

export default SceneKeys;